(function(){
  if(window.__clHeroOfferRefresh2026)return;
  window.__clHeroOfferRefresh2026=true;
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-clmo-offer-trigger]');
    if(!trigger)return;
    event.preventDefault();
    var dialog=document.querySelector('[data-clmo-root] [data-clmo-welcome]');
    if(!dialog||typeof dialog.showModal!=='function')return;
    var alreadyOpen=document.querySelector('dialog[open]');
    if(alreadyOpen&&alreadyOpen!==dialog)return;
    if(!dialog.open){try{dialog.showModal()}catch(e){}}
  });
})();